<template>
  <date-time-picker :label="label || title" first-day-of-week="1" :time-format="timeFormat" :time-buttons="timeButtons" v-model="val"></date-time-picker>
</template>

<script>
import {EventMixin} from '@/lib/mixins.js';
import DateTimePicker from '../DateTimePicker';
import moment from 'moment';

export default {
  mixins: [EventMixin],
  components: {DateTimePicker},
  props: {
    value: {
      type: undefined,
      default: () => ({})
    },
    name: String,
    label: String,
    title: String,
    timeFormat: {
      type: String,
      default: "HH:mm"
    },
    default_value: {
      type: undefined,
      default: ""
    },
    defaultValue: {
      type: undefined,
      default: ""
    },
    'time-buttons': {type: Array, default: () => []}
  },
  created() {
    var value = this.value || {};
    _.set(value, this.name, this.unix);
    this.$emit("input", value);
  },
  computed: {
    unix() {
      var current = _.get(this.value, this.name);
      if (typeof(current) == "number" && isFinite(current)) return current;

      var defVal = this.default_value || this.defaultValue;
      if (typeof(defVal) == "number" && isFinite(defVal)) return defVal;

      var defaultVal = moment();
      if(defVal == "start_of_day") {
        defaultVal = defaultVal.startOf("day");
      } else if (defVal == "end_of_day") {
        defaultVal = defaultVal.endOf("day");
      } else if (defVal && moment(defVal).isValid()) {
        defaultVal = moment(defVal);
      }
      return defaultVal.unix();
    },
    val: {
      get () {
        return moment.unix(this.unix).toDate();
      },
      set (val) {
        var value = _.cloneDeep(this.value);
        _.set(value, this.name, moment(val).unix());
        this.$emit("input", value);
      }
    }
  }
}
</script>